import {
  ADD_SCHEDULE,
  CHANGE_STATUS_SCHEDULE,
  CREATE_TIMESLOTS_FROM_SCHEDULE,
  DELETE_SCHEDULE,
  FETCH_SCHEDULES,
  SET_SELECTED_SCHEDULE,
  UPDATE_SCHEDULE,
} from "../constants/schedules";
import { Schedule } from "../types";
import { getInitActionType } from "../utils";

export function fetchSchedules(officeId: number) {
  return {
    type: FETCH_SCHEDULES,
    api: true,
    payload: {
      method: "GET",
      url: `/offices/${officeId}/schedules`,
    },
    data: { officeId },
  };
}

export function deleteSchedule(scheduleId: number | string, officeId: number | string) {
  return {
    type: DELETE_SCHEDULE,
    api: true,
    payload: {
      method: "DELETE",
      url: `/schedules/${scheduleId}`,
    },
    data: { scheduleId, officeId }, // FIXME: use these data in reducer instead of fetch data from server again?
  };
}

export function addSchedule(officeId: number | string, data: any) {
  return {
    type: ADD_SCHEDULE,
    api: true,
    payload: {
      method: "POST",
      url: "/schedules",
      data: { officeId, ...data },
    },
    data: { officeId },
  };
}

export function updateSchedule(scheduleId: number | string, officeId: string | number, data: any) {
  return {
    type: UPDATE_SCHEDULE,
    api: true,
    payload: {
      method: "PATCH",
      url: `/schedules/${scheduleId}`,
      data,
    },
    data: { scheduleId, officeId },
  };
}

export function disableSchedule(scheduleId: number, officeId: number, data: boolean) {
  return {
    type: CHANGE_STATUS_SCHEDULE,
    api: true,
    payload: {
      method: "PATCH",
      url: `/schedules/${scheduleId}`,
      data: { status: data },
    },
    data: { scheduleId, officeId },
  };
}

export function createTimeslotsFromSchedule(officeId: number | string, startDate?: string, endDate?: string) {
  return {
    type: CREATE_TIMESLOTS_FROM_SCHEDULE,
    api: true,
    payload: {
      method: "POST",
      url: `offices/${officeId}/timeslots/create`,
      data: { startDate, endDate },
    },
    data: { officeId },
  };
}

export function createTimeslotsFromScheduleInit() {
  return {
    type: getInitActionType(CREATE_TIMESLOTS_FROM_SCHEDULE),
  };
}

export function setSelectedSchedule(schedule: Schedule) {
  return {
    type: SET_SELECTED_SCHEDULE,
    payload: schedule,
  };
}
